// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import CollapseIcon from "@flip/XDL/Icons/AngleDown";
import { xBaseTheme } from "@flip/XDL/types";
import { color } from "@flip/XDL/Utilities";
import { AccordionSectionPanel } from "@insite/mobius/AccordionSection";
import AccordionSectionHeader, {
    AccordionSectionHeaderProps,
} from "@insite/mobius/AccordionSection/AccordionSectionHeader";
import AccordionSectionPresentationPropsDefault from "@insite/mobius/AccordionSection/presentationProps";
import { css } from "styled-components";

export default {
    defaultProps: {
        mergeCss: true,
    },
    sectionDefaultProps: {
        ...AccordionSectionPresentationPropsDefault,
        mergeCss: true,
        titleTypographyProps: {
            forwardAs: "span",
            variant: "h6",
            css: css`
                margin-bottom: 0;
            `,
        },
        toggleIconProps: {
            color: "primary",
            src: CollapseIcon,
            size: 10,
            css: css`
                &:hover {
                    color: ${color("common.ui8")};
                }
            `,
        },
        collapseIconProps: {
            src: CollapseIcon,
            size: 10,
            css: css`
                &:hover {
                    color: ${color("common.ui8")};
                }
                transform: rotate(180deg);
            `,
        },
        headerProps: {
            css: css`
                background: ${color("common.background")};
                margin-bottom: 8px;
                &&${AccordionSectionHeader} {
                    button,
                    button:focus {
                        padding: 8px;
                        border-color: ${color("common.border")};
                        border-style: solid;
                        border-width: 1px;
                        border-top: 1px solid ${color("common.border")};
                        border-radius: 8px;
                        background: ${color("common.ui1")};
                    }
                }

                ${({ expanded }: AccordionSectionHeaderProps) =>
                    expanded &&
                    css`
                        margin-bottom: 0;
                        &&${AccordionSectionHeader} {
                            button,
                            button:focus {
                                padding-bottom: 0px;
                                border-bottom: transparent;
                                border-bottom-left-radius: 0;
                                border-bottom-right-radius: 0;
                            }
                        }
                    `};
            `,
        },
        panelProps: {
            css: css`
                background: ${color("common.background")};
                padding: 8px;
                border-bottom-left-radius: 8px;
                border-bottom-right-radius: 8px;
                margin-bottom: 8px;
            `,
        },
    },
} as xBaseTheme["accordion"];
